import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {StoreName} from '@/libs/core/store/store-name';
import { ApplicationUserModel } from '@/libs/Api';
import { ApplicationUserDataService } from '../application-user-data-service';

export const applicationUserStore = registerCrudStore<ApplicationUserModel, ApplicationUserModel>(StoreName.ApplicationUser, new ApplicationUserDataService());